export default "__VITE_ASSET__93702ee5__"